import React from 'react'
import FormUpdate from './FormUpdate'

const CreateOrEditDeviceProfile = (props) => {
    return (
        <FormUpdate {...props} />
    )
}

export default CreateOrEditDeviceProfile;
